<div class="composer" dir="rtl">
  <header class="composer-header">
    <span class="header-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24">
        <path d="M5 4v16M19 4v16M5 8h14M5 16h14M8 4v4M16 4v4M8 16v4M16 16v4"></path>
      </svg>
    </span>
    <span class="header-copy">
      <strong>עריכת הסרטון</strong>
      <small>בחרו את הקטע הטוב ביותר לפני ההעלאה</small>
    </span>
    <span class="duration-limit">עד {{ maxDurationSec }} שניות</span>
    <button class="close-button" type="button" (click)="close()" aria-label="סגירה">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="composer-body">
    <section class="video-area" aria-label="תצוגה מקדימה של הסרטון">
      <video #videoEl class="video" playsinline></video>

      @if (loading) {
        <div class="video-loading" role="status">
          <span class="loading-spinner" aria-hidden="true"></span>
          <span>טוענים את הסרטון...</span>
        </div>
      }

      <button class="play-button" type="button" (click)="togglePlay()" [disabled]="loading" [attr.aria-label]="isPlaying() ? 'עצירת הסרטון' : 'הפעלת הסרטון'">
        <mat-icon>{{ isPlaying() ? 'pause' : 'play_arrow' }}</mat-icon>
      </button>

      <button class="mute-button" type="button" (click)="toggleMute()" [attr.aria-pressed]="muted">
        <mat-icon>{{ muted ? 'volume_off' : 'volume_up' }}</mat-icon>
        <span>{{ muted ? 'מושתק' : 'צליל פעיל' }}</span>
      </button>

      @if (!loading) {
        <span class="preview-range">{{ timeLabel(startSec) }} — {{ timeLabel(endSec) }}</span>
      }
    </section>

    <section class="editor-panel" [class.is-loading]="loading">
      <div class="editor-heading">
        <span>
          <strong>חיתוך הסרטון</strong>
          <small>הזיזו את הסמנים כדי לקבוע את נקודת ההתחלה והסיום</small>
        </span>
        <span class="selected-duration">
          <small>משך הקטע</small>
          <strong>{{ durationLabel() }}</strong>
        </span>
      </div>

      <div class="trim-control">
        <div class="trim-label">
          <span>התחלה</span>
          <strong>{{ timeLabel(startSec) }}</strong>
        </div>
        <input
          class="range start-range"
          type="range"
          aria-label="נקודת התחלה"
          [min]="0"
          [max]="totalSec"
          [step]="0.1"
          [value]="startSec"
          [disabled]="loading"
          (input)="onStartChange($any($event.target).valueAsNumber)" />
      </div>

      <div class="trim-control">
        <div class="trim-label">
          <span>סיום</span>
          <strong>{{ timeLabel(endSec) }}</strong>
        </div>
        <input
          class="range end-range"
          type="range"
          aria-label="נקודת סיום"
          [min]="0"
          [max]="totalSec"
          [step]="0.1"
          [value]="endSec"
          [disabled]="loading"
          (input)="onEndChange($any($event.target).valueAsNumber)" />
      </div>

      <label class="caption-field">
        <span>כיתוב לסרטון <small>(אופציונלי)</small></span>
        <input type="text" maxlength="120" placeholder="הוסיפו כיתוב קצר..." [(ngModel)]="caption" />
        <small class="caption-count">{{ caption.length }}/120</small>
      </label>
    </section>
  </div>

  <footer class="composer-actions">
    <button class="cancel-button" type="button" (click)="close()">ביטול</button>
    <button class="save-button" type="button" (click)="send()" [disabled]="!canSend()">
      <mat-icon>check</mat-icon>
      <span>שמירה והמשך</span>
    </button>
  </footer>
</div>
